"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

require("./_credits-remaining.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function CreditsRemaining(_ref) {
  var balance = _ref.balance,
      isRecurring = _ref.isRecurring,
      isUnlimited = _ref.isUnlimited;
  var balanceToDisplay = isUnlimited ? 'Unlimited' : balance;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('credits-remaining', {
      'credits-remaining--zero-credits': !isUnlimited && balance <= 0
    })
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    prefixIcon: isRecurring ? 'bookings' : 'credits',
    prefixIconColor: "white",
    darkTheme: true
  }, "".concat(balanceToDisplay, " ").concat(isRecurring ? 'recurring' : 'video', " credits remaining")));
}

var _default = (0, _react.memo)(CreditsRemaining);

exports.default = _default;